import type { LicensingStatusAppsResponse, LicensingStatusResponse } from '@protector/entities/company/models';
import { PROTECTOR_APP_ID } from 'config/constants';
import moment from 'moment';

export const getPlanInfo = (license: LicensingStatusResponse | null, key: keyof LicensingStatusAppsResponse['plan']) => {
  const planInfo = new Set();

  return (
    license?.apps?.reduce<LicensingStatusAppsResponse['plan'][keyof LicensingStatusAppsResponse['plan']][]>((acc, app) => {
      if (planInfo.has(app.plan[key])) {
        return acc;
      }

      if (moment().isBefore(app.contract.end) && app.id === PROTECTOR_APP_ID) {
        planInfo.add(app.plan[key]);
        acc.push(app.plan[key]);

        return acc;
      }
      return acc;
    }, []) ?? null
  );
};
